import React, { useEffect, useState } from "react";
import ModalQ from "../../../components/TableBionovaQ/ModalQ/ModalQ";
import ErrorMessage from "../../../components/TableBionovaQ/ErrorMessage/ErrorMessage";
import InputQ from "../../../components/FormComponents/InputQ/InputQ";
import request from "../../../utils/request";
import styles from "./PackageRejectionReasonsForm.module.css";
import SelectQ from "../../../components/FormComponents/SelectQ/SelectQ";
import { toast } from "react-toastify";
import ColorSelect from "../../../components/FormComponents/ColorSelect/ColorSelect";

const PackageRejectionReasonsForm = ({
  formData,
  handleFormData,
  handleClose,
  open,
  locale,
  t,
  getPackagesRR,
}) => {
  const [error, setError] = useState("");
  const [validate, setValidate] = useState(false);
  const [validate2, setValidate2] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [colors, setColors] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title.trim() || !formData.code.trim()) {
      setValidate(true);
      return;
    }
    if (formData.code.trim().length < 6) {
      setValidate2(true);
      return;
    }
    setValidate(false);
    setValidate2(false);
    setIsSaving(true);
    try {
      const bodyRequest = { ...formData };
      if (formData.id) {
        await request().put("/api/Location", bodyRequest);
      } else {
        await request().post("/api/Location", bodyRequest);
      }
      handleClose();
      setError("");
      setValidate(false);
      setValidate2(false);
      getPackagesRR();
    } catch (err) {
      setError(err.response?.data?.message || "Error al guardar ubicación.");
    } finally {
      setIsSaving(false);
    }
  };

  const getColors = async () => {
    try {
      let res = await request().get(`/api/parameter/color`);

      setColors(res.data);
    } catch (e) {
      toast.error(e.response?.data?.messagge);
    }
  };
  useEffect(() => {
    getColors();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "code") {
      const valid = /^[A-Za-z0-9]*$/.test(value);
      if (!valid) {
        toast.info("Only letters and numbers are allowed — no spaces or special characters.");
        return;
      }
    }
  
    handleFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  

  const handleColor = (value) => {
    handleFormData((prevData) => ({ ...prevData, colorId: value.colorId }));
  };

  const onClose = () => {
    handleClose();
    setError("");
    setValidate(false);
    setValidate2(false);
  };

  return (
    <ModalQ
      open={open}
      title={
        !formData.id
          ? t("NewPackageRejectionReason", locale) || "New Package Rejection Reason"
          : t("EditPackageRejectionReason", locale) || "Edit Package Rejection Reason"
      }
      handleClose={onClose}
    >
      {error && <ErrorMessage message={error} />}
      <div className={styles.container}>
        <div className={styles.inputGroup}>
          <InputQ
            containerWidth={"48%"}
            labelTop={true}
            label={t("TitleSpan") || "Title"}
            name="title"
            handleChange={handleInputChange}
            value={formData.title}
            required={true}
            validate={validate}
            leftMessage={true}
          />
          <InputQ
            containerWidth="48%"
            labelTop={true}
            label={t("Code", locale) || "Code"}
            name="code"
            handleChange={handleInputChange}
            value={formData.code}
            required={true}
            validate={validate}
            leftMessage={true}
            additionalMessage="Enter 6 or more characters"
            additionalValidation={validate2}
          />
        </div>
        <div className={styles.inputGroup}>
          <InputQ
            containerWidth="48%"
            labelTop={true}
            label={t("DescriptionSpan", locale) || "Description"}
            name="description"
            handleChange={handleInputChange}
            value={formData.description}
          />
          <div style={{width: "50%"}}>
          <ColorSelect
            label="Color"
            value={formData.colorId}
            onChange={handleColor}
            options={colors}
          />
          </div>
        </div>
        <button
          className={`${styles.button} ${styles.confirmButton}`}
          onClick={handleSubmit}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "Confirm"}
        </button>
      </div>
    </ModalQ>
  );
};

export default PackageRejectionReasonsForm;
